<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/stSffN/tc-custom/9780061997020.jpg?1737195675053" alt="This image is the cover for the book Infinity Gate, DarkGlass Mountain Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Infinity Gate, DarkGlass Mountain Series
      </h1>
      <p class="bookDescription body article font2">
        <p>“Sara Douglass has the breadth of vision necessary to create sweeping epics and the storyteller’s gift that makes readers love her.” </p><p></p><p>—<i>Locus</i></p><p></p><p></p>Sara Douglas fans have been eagerly awaiting the third book of her epic DarkGlass Mountain fantasy trilogy…and now the dramatic conclusion is here! <i>The Infinity Gate</i>—a magnificent tale of love, magic, and betrayal set in the world of her bestselling Wayfarer Redemption—has the sweep, passion, and excitement of the best world-building efforts of Jacqueline Carey, Raymond E. Feist, Robin Hobb, and Lois McMaster Bujold, as it brings Douglas’s breathtaking fantasy saga to a powerful and extraordinarily satisfying end.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sara Douglass
      </h2>
      
      <p class="authorDescription body article"><P>Sara Douglass was born in Adelaide but moved to Hobart in later life to write full-time. Three of her books won the Aurealis Award for Best Fantasy and many were shortlisted. She published nineteen books of epic and historical fantasy before her death in 2011.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?962be5d4